import { useEffect, useState } from "react";
import ListItem from "./listItem";
import ListItemNew from './listItemNew';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { useTaskStore } from '../stores/taskStore';



function List() {
    const sortTasks = useTaskStore(state => state.sortTasks)
    const clearCompletedTasks = useTaskStore(state => state.clearCompletedTasks)
    const taskList = useTaskStore(state => state.tasks)

    const [doSort, setDoSort] = useState(false)

    const sortHandler = () => {
        setDoSort(true);
        sortTasks();
    }

    useEffect( () => {
        setTimeout( () => setDoSort(false), 50)
        
    }, [doSort])

    return (

        <div className="todo-wrapper">
            <div className='todo-header'>
                <div className='todo-actions'>
                    <h5>TODO</h5> 
                    <button className='button-control sort' onClick={sortHandler}><FontAwesomeIcon icon="sort" /></button>
                    <button className='button-control clear' onClick={clearCompletedTasks}><FontAwesomeIcon icon="broom" /></button>
                </div>
                <ListItemNew />
            </div>
            <ul className="todo-list">

                {taskList.map( ( item, index ) => {
                    return(<ListItem name={item.name} status={item.status} index={index} id={item.id} key={item.id} />);
                })}
            </ul>
        </div>
    );
  }
  
  export default List;
  